import './App.css';
import {
	BrowserRouter,
	Routes,
	Route,
  } from "react-router-dom";
import MainPage from './pages/mainpage';
import Purchase from './pages/purchase';
import About from './pages/about';
import Marketplace from './pages/marketplace';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage></MainPage>}></Route>
        <Route path='/purchase' element={<Purchase></Purchase>}></Route>
        <Route path='/about' element={<About></About>}></Route>
        <Route path="/marketplace" element={<Marketplace></Marketplace>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
